export enum PersonType {
  LEGAL_PERSON = 'legal_person',
  NATURAL_PERSON = 'natural_person',
  INTERNATIONAL_PERSON = 'international_person',
}
